import {apiSlice} from './apiSlice';
import {
    StaffProfileCreateParams,
    StaffProfilesResponse,
    StaffProfileUpdateParams
} from '../../types/staffManagementTypes';
import {PaginatedQueryParams} from '../../types/apiTypes';

export const staffManagementInjectedEndpoints = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getStaffProfiles: builder.query<StaffProfilesResponse, PaginatedQueryParams>({
            query: ({page, perPage}) => `/staff?page=${page}&per_page=${perPage}`,
            providesTags: ['StaffManagement'],
        }),
        createStaffProfile: builder.mutation<void, StaffProfileCreateParams>({
            query: (body) => ({
                url: '/staff',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['StaffManagement'],
        }),
        updateStaffProfile: builder.mutation<void, StaffProfileUpdateParams>({
            query: ({profile_id, first_name, last_name, email, roles}) => ({
                'url': `/staff/${profile_id}`,
                method: 'PUT',
                body: {first_name, last_name, email, roles}
            }),
            invalidatesTags: ['StaffManagement'],
        }),
        deleteStaffProfile: builder.mutation<void, number>({
            query: (id) => ({
                url: `/staff/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['StaffManagement'],
        }),
        restoreStaffProfile: builder.mutation<void, number>({
            query: (id) => ({
                url: `/staff/${id}/restore`,
                method: 'PUT',
            }),
            invalidatesTags: ['StaffManagement'],
        }),
    })
});

export const staffManagementEndpoints = staffManagementInjectedEndpoints.endpoints;
export const {
    useGetStaffProfilesQuery,
    useCreateStaffProfileMutation,
    useUpdateStaffProfileMutation,
    useDeleteStaffProfileMutation,
    useRestoreStaffProfileMutation,
} = staffManagementInjectedEndpoints;
